import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=3e62b08c&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=js"
export * from "./order_detail.vue?vue&type=script&lang=js"
import style0 from "./order_detail.css?vue&type=style&index=0&id=3e62b08c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e62b08c",
  null
  
)

export default component.exports